export default {
    API_ORIGIN: null,
    API_URL: null,
    searched: false,
    searchResult: [],
    cashSearchResult: [],
    secondaryFiltersResult: null,
    mainParams: null,
    filterParams: null,
    urlParams: "",
    lastRequest: "",
    direct: 1,
    aviaQuota: 7
}